export default function DateToStringWithTime(date) {
    
    if (!date || date === "" || date === undefined) {
        return undefined
    } else {
        var month = pad2(date.getMonth() + 1);
        var day = pad2(date.getDate());
        var year = date.getFullYear();
        var hour = pad2(date.getHours());
        var minutes = pad2(date.getMinutes());

        return day + "/" + month + "/" + year + " " + hour + ":" + minutes;
    }

}

function pad2(n) {
    return (n < 10 ? '0' : '') + n;
}